import { HTTP } from './index'

/**
 * Get the airport data by query based on airport name of IATA code
 *
 * @param airportQuery 				- a query to search
 * @param country 						- country of the current domain
 *
 * @returns Promise instance that may be resolved and return array with results
 */
function getAirportByQuery (airportQuery: string, country: string = 'de'): Promise<any> {
	return HTTP.get(`/airports?query=${airportQuery}`,
		{
			headers: {
				'X-Domain': country
			}
		}
	)
		.then(response => {
			return response.data
		})
		.catch((e: Error) => {
			console.error('Error occured while trying to retreive airport from claimcheck API: ', e)
		})
}

export default {
	getAirportByQuery
}
